import _toConsumableArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["docid"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-unused-vars */

import React, { useEffect, useContext } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import useSWRImmutable from "swr/immutable";
import dynamic from "next/dynamic";
import Bowser from "bowser";
import { initialStateBase, initSearchScroll, setSearchScrollState } from "redux/reducers/searchScrollReducer";
import { Events } from "services/adobeAnalytics";
import { AppContext, STATUSVALUES } from "contexts/appContext";
import { EvRetrievalApi } from "../../apiclient/api/EvRetrievalApi";
import { Databases } from "../../components/applogic/Databases";
import { ELSDivider } from "../../components/common/elsevier/Divider/Divider";
import { ELSGrid } from "../../components/common/elsevier/Grid/Grid";
import { ELSButton } from "../../components/common/elsevier/Button/Button";
import { ELSHidden } from "../../components/common/elsevier/Hidden/Hidden";
import { ELSAlert } from "../../components/common/elsevier/Alert/Alert";
import { ELSTypography } from "../../components/common/elsevier/Typography/Typography";
import styles from "./doc.module.scss";
import UpRightIcon from "../../components/common/elsevier/Icons/UpRightIcon";
import { selectSearchHistoryState } from "../../redux/reducers/searchHistoryReducer";
import { selectSessionSettings } from "../../redux/reducers/sessionSettingsReducer";
import Skeleton from "../../components/fragments/doc/Loading";

// const StickyContent = dynamic(() => import("../../components/fragments/doc/StickyContent/StickyContent"));
var ArticleToolbar = dynamic(function () {
  return import("../../components/fragments/doc/ArticleToolbar/ArticleToolbar");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/ArticleToolbar/ArticleToolbar")];
    }
  }
});
var CitationInformation = dynamic(function () {
  return import("../../components/fragments/doc/CitationInfo/CitationInfo");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/CitationInfo/CitationInfo")];
    }
  }
});
var MainArticle = dynamic(function () {
  return import("../../components/fragments/doc/MainArticle/MainArticle");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/MainArticle/MainArticle")];
    }
  }
});
var MainArticleCheckbox = dynamic(function () {
  return import("../../components/fragments/doc/MainArticle/MainArticleCheckbox");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/MainArticle/MainArticleCheckbox")];
    }
  }
});
var Navigation = dynamic(function () {
  return import("../../components/fragments/doc/Navigation/Navigation");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/Navigation/Navigation")];
    }
  }
});
var RecordBody = dynamic(function () {
  return import("../../components/fragments/doc/RecordBody");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/RecordBody")];
    }
  }
});
var RelatedDocuments = dynamic(function () {
  return import("../../components/fragments/doc/RelatedDocuments/RelatedDocuments");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/RelatedDocuments/RelatedDocuments")];
    }
  }
});
var ArticleHeader = dynamic(function () {
  return import("../../components/fragments/doc/Header/ArticleHeader");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/fragments/doc/Header/ArticleHeader")];
    }
  }
});
var retrievalApi = new EvRetrievalApi();
function mapSearchType(searchType) {
  if (searchType === "Quick" || searchType === "Thesaurus") {
    return "quickSearch";
  }
  if (searchType === "TagSearch") {
    return "tagSearch";
  }
  if (typeof searchType === "undefined") {
    return undefined;
  }
  return "expertSearch";
}
function RecordViewEvent(_ref) {
  var docid = _ref.docid,
    props = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    Events.combinedRecordPage.load(props);
  }, [docid]);
  return null;
}

/**
 * The EV record page when called with document identifier.
 * @param {object} props Page props
 * @returns JSX for EV record page
 */
function RecordPage() {
  var _browserInfo$parsedRe, _browserInfo$parsedRe2, _data$PAGE, _data$PAGE$PAGERESUL, _data$PAGE$PAGERESUL$, _data$PAGE$PAGERESUL$2, _json$DOCUMENTPROPERT, _json$DOC, _json$DOC$DB, _json$DOC2, _json$DOC2$DB;
  var _useContext = useContext(AppContext),
    appStatus = _useContext.status;

  // Get page parameters:
  // - docid = Document identifier, used for shareable URLs or for one-offs like patent references or standard versions.
  // - searchid = Identifier for an associated search.  Used to build the "Back to results" link and to fetch search info.
  // - index = requires searchid and indicates the position of the document in the search; defaults to first doc if not present.
  // - searchtype = quick | expert | thesaurus | tagsearch
  var router = useRouter();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    stickyNavVisible = _React$useState2[0],
    setStickyNavVisible = _React$useState2[1];
  var queryParams = router.query;
  var docid = queryParams.docid,
    searchId = queryParams.searchId,
    index = queryParams.index;
  var searchhistory = useSelector(selectSearchHistoryState);
  var dispatch = useDispatch();

  // Allows special handling/override of a feature ie lazyload display of matrix navigation link
  // Uses name/value pairs
  var _React$useState3 = React.useState(new Map()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    featureOverride = _React$useState4[0],
    setFeatureOverride = _React$useState4[1];

  // Certain state defaults need to be set by docid.  Stepping through search results via
  // next page, next page, etc will not reset state back to defaults per docid.
  // Associating with docid key helps with prev page, prev page, etc issues
  useEffect(function () {
    // Use overrideFeature if preserving the previous state overrides
    if (!featureOverride.get(docid)) {
      setFeatureOverride(featureOverride.set(docid, {
        metrics: false
      }));
    }
  }, [docid]);
  useEffect(function () {
    if (searchhistory) {
      dispatch(setSearchScrollState(_objectSpread({
        status: "init"
      }, initialStateBase)));
      initSearchScroll(queryParams, searchhistory).then(function (result) {
        dispatch(setSearchScrollState(result));
      })["catch"](function (error) {
        dispatch(setSearchScrollState(_objectSpread({
          status: "error"
        }, initialStateBase)));
      });
    }
  }, [searchhistory, queryParams]);
  var historyState = useSelector(selectSearchHistoryState);
  var sessionSettings = useSelector(selectSessionSettings);
  var navLimit = 5000;
  var searchHistoryEntity = {};
  if (searchId && historyState.ids.includes(searchId)) {
    searchHistoryEntity = _objectSpread({}, historyState.entities[searchId]);
    searchHistoryEntity.highlightingEnabled = true;
  }
  var toggleStickyNavVisible = function toggleStickyNavVisible(visible) {
    setStickyNavVisible(visible);
  };
  var opts = {
    docIndex: queryParams.index,
    searchId: queryParams.searchId,
    resultCount: queryParams.resultsCount,
    usageOrigin: queryParams.usageOrigin,
    usageZone: queryParams.usageZone,
    searchType: mapSearchType(queryParams.searchType),
    emailAlertWeek: queryParams.emailAlertWeek,
    partnerId: queryParams.partnerId,
    activity: queryParams.activity
  };

  // Alert customization
  var alertSeverity = "";
  var alertAction = "";
  var alertMessage = "";
  var preprintAlertMessage = false;
  var browserInfo = Bowser.getParser(navigator.userAgent);
  var browser = (_browserInfo$parsedRe = browserInfo.parsedResult) === null || _browserInfo$parsedRe === void 0 ? void 0 : (_browserInfo$parsedRe2 = _browserInfo$parsedRe.browser) === null || _browserInfo$parsedRe2 === void 0 ? void 0 : _browserInfo$parsedRe2.name;
  var _React$useState5 = React.useState(index >= navLimit),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showNavLimitExceededMessage = _React$useState6[0],
    setShowNavLimitExceededMessage = _React$useState6[1]; // Result set, navigation limit
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    emptySpace = _React$useState8[0],
    setEmptySpace = _React$useState8[1];
  useEffect(function () {
    setShowNavLimitExceededMessage(index >= navLimit);
  }, [docid]);
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    open = _React$useState10[0],
    setOpen = _React$useState10[1]; // state of selected records popup alert message for > 1000 records

  // Build recordbody object. Update. Scroll to ref is left in place in order to resolve the first click bug.
  var scrollToRef = function scrollToRef(ref) {
    var isAccordion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var recordBodyHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // Local variable holding additional space
    var additionalSpace = 0;
    // Adjust the additional space in case the child component does noit fit in the recirdBody component height-wise
    if (ref.current.offsetTop - recordBodyHeight > 0) {
      additionalSpace = ref.current.offsetTop - recordBodyHeight;
      setEmptySpace(additionalSpace + 100);
    } else setEmptySpace(0);
    if (isAccordion && !ref.current.firstChild.className.includes("Mui-expanded")) {
      ref.current.firstChild.firstChild.click();
    }

    // scrollTo function works on top of HTML anchor tags to provide a smooth scrolling effect
    // ONLY FOR FIREFOX: In case of Firefox increase the timeout.
    if (browser.includes("Firefox")) {
      setTimeout(function () {
        window.scrollTo({
          left: 0,
          top: ref.current.offsetTop - 100,
          behavior: "smooth"
        });
      }, 100);
    } else {
      setTimeout(function () {
        window.scrollTo({
          left: 0,
          top: ref.current.offsetTop - 100,
          behavior: "smooth"
        });
      }, 20);
    }
    if (isAccordion) {
      /* TODO: wait for scroll to finish before changing focus */
      ref.current.firstChild.firstChild.focus();
    } else {
      ref.current.firstChild.focus();
      document.querySelector("#abstract").focus(); // isAccordion = false -> set the focus to Abstract (only not according item)
    }
  };
  var recordBodyObject = {
    recordBody: {
      ref: React.useRef(null),
      id: "record-body"
    },
    "abstract": {
      ref: React.useRef(null),
      id: "abstract",
      scrollToRef: scrollToRef
    },
    versions: {
      ref: React.useRef(null),
      id: "versions",
      scrollToRef: scrollToRef
    },
    indexing: {
      ref: React.useRef(null),
      id: "indexing",
      scrollToRef: scrollToRef
    },
    metrics: {
      ref: React.useRef(null),
      id: "metrics",
      scrollToRef: scrollToRef
    },
    patent: {
      ref: React.useRef(null),
      id: "patent",
      scrollToRef: scrollToRef
    },
    conference: {
      ref: React.useRef(null),
      id: "conference",
      scrollToRef: scrollToRef
    },
    funding: {
      ref: React.useRef(null),
      id: "funding",
      scrollToRef: scrollToRef
    },
    bibliographic: {
      ref: React.useRef(null),
      id: "bibliographic",
      scrollToRef: scrollToRef
    },
    patentrefs: {
      ref: React.useRef(null),
      id: "patentrefs",
      scrollToRef: scrollToRef
    },
    refs: {
      ref: React.useRef(null),
      id: "refs",
      scrollToRef: scrollToRef
    },
    otherrefs: {
      ref: React.useRef(null),
      id: "otherrefs",
      scrollToRef: scrollToRef
    }
  };

  //* **********************************************************************************
  // TODO - return error message if trying to access record from database NOT entitled!
  //* **********************************************************************************

  // Try to load data via SWR

  var _useSWRImmutable = useSWRImmutable([retrievalApi, docid], function () {
      return retrievalApi.getRecordPost(searchHistoryEntity, [docid], opts);
    }, null),
    data = _useSWRImmutable.data,
    error = _useSWRImmutable.error;
  if (error) {
    console.error({
      error: error
    });
    return /*#__PURE__*/React.createElement(Error, {
      id: docid
    });
  }

  // don't render page until we have data and selected records have loaded
  if (appStatus !== STATUSVALUES.DONE || !data) return /*#__PURE__*/React.createElement(Skeleton, null);

  // Valid data?
  if (!(data !== null && data !== void 0 && (_data$PAGE = data.PAGE) !== null && _data$PAGE !== void 0 && (_data$PAGE$PAGERESUL = _data$PAGE["PAGE-RESULTS"]) !== null && _data$PAGE$PAGERESUL !== void 0 && (_data$PAGE$PAGERESUL$ = _data$PAGE$PAGERESUL["PAGE-ENTRY"]) !== null && _data$PAGE$PAGERESUL$ !== void 0 && (_data$PAGE$PAGERESUL$2 = _data$PAGE$PAGERESUL$[0]) !== null && _data$PAGE$PAGERESUL$2 !== void 0 && _data$PAGE$PAGERESUL$2["EI-DOCUMENT"])) return /*#__PURE__*/React.createElement(Error, {
    id: docid
  });
  var json = data.PAGE["PAGE-RESULTS"]["PAGE-ENTRY"][0]["EI-DOCUMENT"];
  var getCookie = function getCookie(name) {
    var match = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
    if (match) return match[2];
    return "";
  };

  // Preprint document?
  if ((json === null || json === void 0 ? void 0 : (_json$DOCUMENTPROPERT = json.DOCUMENTPROPERTIES) === null || _json$DOCUMENTPROPERT === void 0 ? void 0 : _json$DOCUMENTPROPERT.DT) === "Preprint (PP)") {
    // Check cookie value
    if (getCookie("ev_hidePreprintMessage") !== "true") {
      preprintAlertMessage = true;
    }
  }
  var handleClose = function handleClose() {
    if (preprintAlertMessage) {
      preprintAlertMessage = false;
      document.cookie = "ev_hidePreprintMessage=true;path=/";
      var _aMessage = document.getElementsByClassName("--alertmessage");
      if (_aMessage && _aMessage.length > 0) {
        _aMessage[0].style.display = "none";
      }
    }
    if (showNavLimitExceededMessage) {
      setShowNavLimitExceededMessage(false);
    }
    setOpen(false);
  };
  var setNavLimitExceededMessage = function setNavLimitExceededMessage() {
    alertSeverity = "info";
    alertAction = /*#__PURE__*/React.createElement(ELSButton, {
      className: "es-link__blue--14-font",
      color: "inherit",
      size: "small",
      onClick: handleClose
    }, "Close");
    alertMessage = /*#__PURE__*/React.createElement(React.Fragment, null, "You can only view the first 5000 records. Run a new search or reduce the number of results by using the Refine results panel.");
  };
  var setPreprintAlertMessage = function setPreprintAlertMessage() {
    // toggle error is higher priority
    alertSeverity = "info";
    alertAction = /*#__PURE__*/React.createElement(ELSButton, {
      className: "es-link__blue--14-font",
      color: "inherit",
      size: "small",
      onClick: handleClose
    }, "Close");
    alertMessage = /*#__PURE__*/React.createElement(React.Fragment, null, "This is a Preprint article. To exclude them, please filter by document type.\xA0", /*#__PURE__*/React.createElement(ELSButton, {
      className: "es-link__blue--14-font",
      rel: "noopener nofollow noreferrer",
      target: "_blank",
      href: "https://service.elsevier.com/app/answers/detail/a_id/34654/supporthub/engineering-village/",
      endIcon: /*#__PURE__*/React.createElement(UpRightIcon, {
        "aria-hidden": "true"
      })
    }, "Learn more"));
  };
  var setBasketAlertMessage = function setBasketAlertMessage() {
    alertSeverity = "warning";
    alertAction = /*#__PURE__*/React.createElement(ELSButton, {
      className: "es-link__blue--14-font",
      color: "inherit",
      size: "small",
      onClick: handleClose
    }, "Close");
    alertMessage = /*#__PURE__*/React.createElement(ELSTypography, null, "You have already selected a maximum of 1000 records. You can view all currently selected records by clicking 'Selected records'.");
  };
  var createAlertMessage = function createAlertMessage() {
    // Action alerts, higher priority
    if (showNavLimitExceededMessage) {
      setNavLimitExceededMessage();
    } else if (open) {
      setBasketAlertMessage();
    } else {
      setPreprintAlertMessage();
    }
    return /*#__PURE__*/React.createElement(ELSGrid, {
      className: "".concat(styles["alert-message"], " --alertmessage")
    }, /*#__PURE__*/React.createElement(ELSAlert, {
      severity: alertSeverity,
      action: alertAction
    }, alertMessage));
  };
  var overrideFeature = function overrideFeature(override) {
    var docFeature = featureOverride.get(docid);
    docFeature = _objectSpread(_objectSpread({}, docFeature || {}), override || {});
    var newFeatureOverride = new Map([].concat(_toConsumableArray(featureOverride.entries()), [[docid, docFeature]]));
    setFeatureOverride(newFeatureOverride);
  };
  var isHighlightingEnabled = function isHighlightingEnabled() {
    // if set to #000000, highlighting is off
    var highlightOn = sessionSettings.highlight === "#ffffaa";
    return highlightOn;
  };
  var buildRecordClassName = "".concat(styles["record-page"], " --record-page");
  if (isHighlightingEnabled()) {
    buildRecordClassName += " ".concat(styles["record-page-highlight"], " record-page-highlight");
  } else {
    buildRecordClassName += " ".concat(styles["record-page-no-highlight"]);
  }

  // Record page layout
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    id: "record-page-article-toolbar",
    className: "".concat(styles["article-toolbar-section"])
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    className: "".concat(styles["article-toolbar"], " ev--nonprintable sticky")
  }, /*#__PURE__*/React.createElement(ArticleToolbar, {
    docid: docid,
    json: json
  }), (open || preprintAlertMessage || showNavLimitExceededMessage) && createAlertMessage()))), /*#__PURE__*/React.createElement("section", {
    id: "record-page",
    className: buildRecordClassName
  }, /*#__PURE__*/React.createElement(ArticleHeader, {
    data: json
  }), /*#__PURE__*/React.createElement(RecordViewEvent, {
    json: json,
    searchHistoryEntity: searchHistoryEntity,
    docid: docid
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 2,
    className: "".concat(styles["article-navigation--grid"], " ev--nonprintable ev__navTab")
  }, !stickyNavVisible && /*#__PURE__*/React.createElement(Navigation, {
    key: docid,
    json: json,
    active: "abstract",
    recordBodyObject: recordBodyObject,
    featureOverride: featureOverride.get(docid)
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 10
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    className: "ev--nonprintable"
  }, /*#__PURE__*/React.createElement(MainArticleCheckbox, {
    docid: docid,
    json: json,
    setOpen: setOpen
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 11,
    lg: 7,
    className: styles["main-article"]
  }, /*#__PURE__*/React.createElement(MainArticle, {
    docid: docid,
    json: json
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 11,
    lg: 4,
    className: styles["citation-information"]
  }, /*#__PURE__*/React.createElement(CitationInformation, {
    json: json,
    searchHistoryEntity: searchHistoryEntity
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSDivider, {
    height: 6
  }), " ", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    className: "".concat(styles["empty-grid"], " ev--nonprintable")
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 11,
    lg: 7,
    className: styles["record-body"]
  }, /*#__PURE__*/React.createElement(RecordBody, {
    key: docid,
    json: json,
    recordBodyObject: recordBodyObject,
    searchHistoryEntity: searchHistoryEntity,
    overrideFeature: overrideFeature
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 11,
    lg: 4,
    className: styles["related-documents"]
  }, (((_json$DOC = json.DOC) === null || _json$DOC === void 0 ? void 0 : (_json$DOC$DB = _json$DOC.DB) === null || _json$DOC$DB === void 0 ? void 0 : _json$DOC$DB.ID) === Databases.cpx.searchcode || ((_json$DOC2 = json.DOC) === null || _json$DOC2 === void 0 ? void 0 : (_json$DOC2$DB = _json$DOC2.DB) === null || _json$DOC2$DB === void 0 ? void 0 : _json$DOC2$DB.ID) === Databases.ins.searchcode) && /*#__PURE__*/React.createElement(RelatedDocuments, {
    json: json
  }))))), emptySpace !== 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "".concat(emptySpace, "px")
    }
  })));
}
RecordPage.title = "Record";
RecordPage.skeleton = Skeleton;
export default RecordPage;
function Error(props) {
  var id = props.id,
    error = props.error;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ELSTypography, {
    component: "h2",
    variant: "h3"
  }, "An error has occurred trying to load this document."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, "Document identifier: ", id), error && /*#__PURE__*/React.createElement("div", null, "Error: ", error));
}

// // This gets called on every request
// export async function getServerSideProps() {
//   const { data, error } = useSWRImmutable([
//     retrievalApi,
//     retrievalApi.getRecordPost,
//     searchHistoryEntity,
//     [docid],
//     opts,
//   ]);
//   // Pass data to the page via props
//   return { props: { data, error } }
// }